import debounce from 'lodash/debounce';

import { SearchRoundedIcon } from '../../icons';
import { TextField } from '../TextField';

export interface SearchInputProps {
  defaultValue?: string;
  placeholder?: string;
  debounceTime?: number;
  onChange?: (value: string) => void;
}

export default function SearchInput(props: Readonly<SearchInputProps>) {
  const { defaultValue, onChange, debounceTime = 700, placeholder } = props;

  const handleSearch = debounce((value: string) => {
    onChange?.(value);
  }, debounceTime);

  return (
    <TextField
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={(event) => {
        handleSearch(event.target.value);
      }}
      slotProps={{
        input: {
          startAdornment: (
            <SearchRoundedIcon
              sx={{ fontSize: '24px', color: (theme) => theme.palette.grey[500] }}
            />
          ),
        },
      }}
    />
  );
}
